import {
  normalizeIndustryTicker,
  normalizeIndustryTickers,
} from '../configs/industryDatasetState';

const getTickerSymbol = (item) => normalizeIndustryTicker(item?.ticker || item);

export const buildTickerSelection = (items = [], allTickers = []) => {
  const optionsByTicker = new Map(
    (allTickers || [])
      .map((option) => [getTickerSymbol(option), option])
      .filter(([ticker]) => Boolean(ticker))
  );

  return normalizeIndustryTickers(items)
    .map((ticker) => {
      const option = optionsByTicker.get(ticker);
      if (option) return option;
      return { ticker, name: ticker };
    })
    .sort((a, b) => String(a.ticker || '').localeCompare(String(b.ticker || '')));
};

export const resolveTickerFilters = ({
  selectedTickers = [],
  storedTickerFilters = [],
} = {}) => {
  const normalizedSelectedTickers = normalizeIndustryTickers(selectedTickers);
  return normalizedSelectedTickers.length > 0
    ? normalizedSelectedTickers
    : normalizeIndustryTickers(storedTickerFilters);
};

export const resolveCompanyTickerFilter = ({
  selectedTicker,
  storedTickerFilters = [],
} = {}) => (
  normalizeIndustryTicker(selectedTicker)
  || normalizeIndustryTickers(storedTickerFilters)[0]
  || ''
);

export const resolveCompanyDetailTicker = ({
  routeTicker,
  storedTickerFilters = [],
  selectedTicker,
} = {}) => (
  normalizeIndustryTicker(routeTicker)
  || normalizeIndustryTickers(storedTickerFilters)[0]
  || normalizeIndustryTicker(selectedTicker)
  || ''
);
